import * as React from "react";
import { Col, Button, Row, Tooltip } from 'antd';
import "./ExpenseViewCategoryAndValue.scss";
import { ExpenseCategoryLabel, ExpenseCategoryEnum } from 'src/services/Enum/ExpenseCategoryEnum';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IExpenseItemCreate } from 'src/services/interfaces/Expense/IExpenseItemCreate';
import { formatCurrency } from 'src/util/Masks/formatCurrency';

interface IExpenseViewCategoryAndValueProps {
    listCategory: IExpenseItemCreate;
    onRemoveItem: (categoryDeleted: ExpenseCategoryEnum) => void;
}

export const ExpenseViewCategoryAndValue: React.FC<IExpenseViewCategoryAndValueProps> = ({
    listCategory,
    onRemoveItem
}) => {

    return (
        <>
            <Row gutter={26} type="flex" justify="space-between" align="middle" style={{ marginBottom: '0.5rem' }}>
                <Col xs={24} sm={24} md={20} lg={20}>
                    <span>
                        <b>{ExpenseCategoryLabel.get(listCategory.category)}</b><br />
                        {formatCurrency(listCategory.value)}
                    </span>
                </Col>
                <Col xs={24} sm={24} md={4} lg={4}>
                    <Tooltip title={`Remover essa categoria e valor`}>
                        <Button type="danger" className="icon-only remove btn" onClick={() => onRemoveItem(listCategory.category)}>
                            <FontAwesomeIcon icon={faTrash} color="red" />
                        </Button>
                    </Tooltip>
                </Col>
            </Row>
        </>
    );
}


// WEBPACK FOOTER //
// ./src/components/common/ExpenseItemCard/ExpenseViewCategoryAndValue/ExpenseViewCategoryAndValue.tsx